import { render, staticRenderFns } from "./ImprovedSurveyList.vue?vue&type=template&id=35dac424&scoped=true"
import script from "./ImprovedSurveyList.vue?vue&type=script&lang=js"
export * from "./ImprovedSurveyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dac424",
  null
  
)

export default component.exports